var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('H5',[_vm._v("PROFIT & LOSS")]),_c('FinanceTable',{key:_vm.plant,attrs:{"card_title":"CONSOL","segment":1,"plant":_vm.plant}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }